export const Types = {
  INITIALIZE: 'uiHome/INITIALIZE',
};

export const Actions = {
  initialize: () => ({
    type: Types.INITIALIZE,
  }),
};



// WEBPACK FOOTER //
// ./src/redux/ui/home/actions.js